import React from "react";

import ResourceItem from "components/ResourceItem";

export default function ResourcePage({ resource, title, phase }) {
  return (
    <section className="section">
      <h3 className="title is-3">{title}</h3>
      {resource.map((item) => {
        // console.log(phase, item);
        return phase in item.assets ? (
          <ResourceItem
            topic={item.title}
            phase={phase}
            assets={item.assets[phase]}
            key={item.topic}
            submission={null}
          />
        ) : null;
      })}
    </section>
  );
}
